import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Enregistrement du service worker (rend l'application installable - PWA)
// + mise a jour automatique : recharge l'app des qu'une nouvelle version est prete.
if ("serviceWorker" in navigator) {
  let rechargement = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (rechargement) return;
    rechargement = true;
    window.location.reload();
  });

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL || ""}/service-worker.js`)
      .then((registration) => {
        // Verifie regulierement s'il existe une nouvelle version
        registration.update();
        setInterval(() => registration.update(), 60_000);
        registration.addEventListener("updatefound", () => {
          const nouveau = registration.installing;
          if (!nouveau) return;
          nouveau.addEventListener("statechange", () => {
            if (nouveau.state === "installed" && navigator.serviceWorker.controller) {
              // Une nouvelle version est prete -> on l'active immediatement
              nouveau.postMessage && nouveau.postMessage({ type: "SKIP_WAITING" });
            }
          });
        });
      })
      .catch(() => {});
  });
}

